<div fxLayout="row" fxLayoutAlign="end center" [ngClass]="{'cell-edit-overlay-inline': inlineEdit, 'cell-edit-overlay': !inlineEdit}">
    <forge-icon-button dense (click)="leaveCellEdit(true)" theme="error">
        <forge-tooltip placement="bottom">
            <span>Cancel cell changes (ESC)</span>
        </forge-tooltip>
        <forge-icon name="close" style="--forge-icon-color: var(--forge-theme-error)"></forge-icon>
    </forge-icon-button>
    <forge-icon-button dense (click)="leaveCellEdit(false)" theme="success">
        <forge-tooltip placement="bottom">
            <span>Accept cell changes (Enter)</span>
        </forge-tooltip>
        <forge-icon name="check" style="--forge-icon-color: var(--forge-theme-success)"></forge-icon>
    </forge-icon-button>
</div>
